<template>
    <div class="d-flex justify-content-center align-self-center vh-100 align-items-center">
        <div class="spinner-border text-danger m-5" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</template>

